import { render, staticRenderFns } from "./InlineGoal.vue?vue&type=template&id=80215f36&"
import script from "./InlineGoal.vue?vue&type=script&lang=js&"
export * from "./InlineGoal.vue?vue&type=script&lang=js&"
import style0 from "./InlineGoal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports